import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/common/Reveal";
import { useImagery } from "@/hooks/useCatalog";

export function PromoBanner() {
  const { data } = useImagery();
  const img = data?.promo;

  return (
    <section className="relative overflow-hidden bg-ink">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-stretch lg:grid-cols-2">
        <div className="flex flex-col justify-center px-6 py-16 sm:px-10 lg:py-28 lg:pl-8 lg:pr-16">
          <Reveal>
            <span className="text-luxe text-xs font-medium text-gold">The Everyday Edit</span>
            <h2 className="mt-4 font-serif text-3xl font-light leading-tight text-ivory sm:text-4xl lg:text-5xl">
              Designed for Every Occasion
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-ivory/70">
              From everyday elegance to unforgettable moments — find the piece that speaks to you and the ones you love.
            </p>
            <Link
              to="/shop"
              data-testid="promo-shop-cta"
              className="mt-8 inline-block w-fit bg-gold px-9 py-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-gold-dark"
            >
              Shop The Collection
            </Link>
          </Reveal>
        </div>
        <div className="relative min-h-[320px] overflow-hidden lg:min-h-[520px]">
          <img src={img} alt="ÉLORA jewellery in signature packaging" className="h-full w-full object-cover object-center" />
        </div>
      </div>
    </section>
  );
}
